<script>
  import SinInformacion from "../../components/Sin_informacion.svelte"
  import Spinner from "../../components/Spinner.svelte"
  import getMoneda, { redondear } from "../../services/moneda.js"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/User"
  import { navigate } from "svelte-routing"

  export let documento

  let data = {
    persona: undefined,
    loading: false,
  }

  let session_key = $user.session_key

  const cargarDatos = async () => {
    const ops = "deudas_utilizacion"
    data.loading = true
    const response = await fetch(
      `${BASE_URL}persona.php?documento=${documento}&session_key=${session_key}&ops=${ops}`,
    )
    const resp = await response.json()

    if (resp.status == "error") {
      navigate("/", { replace: true })
    }

    data = {
      persona: resp.data,
      loading: false,
    }

    if (data.persona.length > 0) {
      data.persona.total_linea_otorgada = redondear(
        data.persona
          .map((item) => parseFloat(item.linea_otorgada))
          .reduce((prev, curr) => prev + curr, 0),
      )

      data.persona.total_linea_no_utilizada = redondear(
        data.persona
          .map((item) => parseFloat(item.linea_no_utilizada))
          .reduce((prev, curr) => prev + curr, 0),
      )

      data.persona.total_linea_utilizada = redondear(
        data.persona
          .map((item) => parseFloat(item.linea_utilizada))
          .reduce((prev, curr) => prev + curr, 0),
      )
    }
  }

  cargarDatos()

  const calcPorcentaje = (valor, total) => {
    if (parseFloat(valor) * 100 == 0 && parseFloat(total) == 0) return "0%"

    let porcentaje = (parseFloat(valor) * 100) / parseFloat(total)

    return `${Math.round(porcentaje)}%`
  }
</script>

{#if data.loading === true}
  <Spinner />
{:else if data.persona.length === 0}
  <SinInformacion />
{:else if data.persona !== undefined}
  <div class="table-responsive">
    <table class="table table-striped table-sm">
      <thead class="text-end">
        <tr>
          <th class="fg-secondary fw-normal text-start">Entidad</th>
          <th class="fg-secondary fw-normal">Linea aprobada</th>
          <th class="fg-secondary fw-normal">Linea no utilizada</th>
          <th class="fg-secondary fw-normal">Linea utilizada</th>
          <th class="fg-secondary fw-normal">%L. Utilizada</th>
        </tr>
      </thead>
      <tbody class="text-end">
        {#each data.persona as deuda}
          <tr>
            <td class="text-start">{deuda.empresa}</td>
            <td>{getMoneda(deuda.linea_otorgada)}</td>
            <td>{getMoneda(deuda.linea_no_utilizada)}</td>
            <td>{getMoneda(deuda.linea_utilizada)}</td>
            <td
              >{calcPorcentaje(deuda.linea_utilizada, deuda.linea_otorgada)}</td
            >
          </tr>
        {/each}
      </tbody>
      <tfoot class="text-end">
        <tr>
          <td class="fg-secondary fw-normal text-start">Total</td>
          <td>{getMoneda(data.persona.total_linea_otorgada)}</td>
          <td>{getMoneda(data.persona.total_linea_no_utilizada)}</td>
          <td>{getMoneda(data.persona.total_linea_utilizada)}</td>
          <td
            >{calcPorcentaje(
              data.persona.total_linea_utilizada,
              data.persona.total_linea_otorgada,
            )}</td
          >
        </tr>
      </tfoot>
    </table>
  </div>
{/if}
